<div
  class="formgrid grid overflow-visible"
  style="display: flex; flex-direction: column"
>
  <div class="box">
    <p>Manually Enter User Names and emails or Upload a CSV of users</p>
  </div>
  <div class="box">
    <h2>Upload Method</h2>
    <div class="box">
      <div class="options gap-2">
        <div>
          <p-radiobutton
            [(ngModel)]="uploadMethod"
            inputId="upload_csv"
            name="r_button"
            value="upload"
          />
          <label class="ml-2" for="upload_csv">Upload CSV</label>
        </div>

        <div>
          <p-radiobutton
            [(ngModel)]="uploadMethod"
            inputId="manual_upload"
            name="r_button"
            value="manual"
          />
          <label class="ml-2" for="manual_upload">Manual Upload</label>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="uploadMethod === 'upload'">
    <div class="box bottom-padding">
      <lib-upload-csv
        (csvRows)="onUpload($event)"
        [columns]="['name', 'email']"
        [header]="true"
      ></lib-upload-csv>
    </div>
  </div>
  <div *ngIf="uploadMethod === 'manual'">
    <div class="box">
      <lib-manual-add
        (rows)="onManual($event)"
        [columns]="columns"
      ></lib-manual-add>
    </div>
  </div>
</div>
<div class="flex justify-content-end gap-2">
  <p-button (onClick)="cancel()" [outlined]="true" label="Cancel" />
  <p-button (onClick)="upload()" label="Upload" />
</div>
